import "./AddAttendance.css";
import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import AddAttendanceViewModel from "./AddAttendanceViewModel";
import { Avatar } from "@mui/material";
import { StringAvatar } from "../../../../Helpers/StringAvatar";

const AddAttendance = () => {
  const {
    ClassID,
    CourseID,
    StudentsArray,
    Students,
    setStudents,
    CreateAttendance,
    FormDisabled,
    AttendanceDetails,
    setAttendanceDetails,
    MarkStudentPresent,
    MarkStudentAbsent,
    CheckIsAbsent,
    CheckIsPresent,
    MarkAllStudentsAsPresent,
    MarkAllStudentsAsAbsent,
    CheckAllStatus,
    setCheckAllStatus,
  } = AddAttendanceViewModel();

  return (
    <Fragment>
      {/* Page Wrapper */}
      <div className="page-wrapper add-attendance-page">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Add Attendance</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">Dashboard</a>
                  </li>
                  <li className="breadcrumb-item active">Add Attendance</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="student-group-form">
            <div className="row">
              <div className="col-lg-3 col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by ID ..."
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by Name ..."
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by Year ..."
                  />
                </div>
              </div>
              <div className="col-lg-2">
                <div className="search-student-btn">
                  <button type="btn" className="btn btn-primary">
                    Search
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  {/* Page Header */}
                  <div className="page-header">
                    <div className="row align-items-center">
                      <div className="col present-absent-attendance-buttons-header">
                        <h3 className="page-title">Add Attendance</h3>
                        <div className="present-absent-attendance-buttons">
                          <button
                            onClick={MarkAllStudentsAsAbsent}
                            className={`${
                              CheckAllStatus === "AllAbsent"
                                ? "mark-as-absent-active"
                                : "mark-as-absent"
                            }`}
                          >
                            Mark All Absent
                          </button>
                          <button
                            onClick={MarkAllStudentsAsPresent}
                            className={`${
                              CheckAllStatus === "AllPresent"
                                ? "mark-as-present-active"
                                : "mark-as-present"
                            }`}
                          >
                            Mark All Present
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /Page Header */}
                  <table className="table border-0 star-student table-hover table-center mb-0 datatable table-striped">
                    <thead className="student-thread">
                      <tr>
                        <th>Profile</th>
                        <th>Name</th>
                        <th>Registration No</th>
                        <th>Gender</th>
                        <th className="text-end">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {StudentsArray &&
                        StudentsArray.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                <Avatar
                                  className="string-avatar"
                                  {...StringAvatar(
                                    item?.FirstName + " " + item?.LastName
                                  )}
                                />
                              </td>
                              <td>{`${item?.FirstName} ${item?.LastName}`}</td>
                              <td>
                                {item?.AdditionalDetails?.StudentRegistrationNo}
                              </td>
                              <td className="text-capitalize">
                                {item?.Gender}
                              </td>

                              <td className="text-end">
                                <div className="actions">
                                  <button
                                    className={`
                                  btn btn-sm me-2 absent
                                  ${CheckIsAbsent(item) && "absent-active"}`}
                                    onClick={() => {
                                      MarkStudentAbsent(item.id);
                                      if (CheckAllStatus === "AllPresent") {
                                        setCheckAllStatus("");
                                      }
                                    }}
                                  >
                                    Absent
                                  </button>

                                  <button
                                    className={`
                                    btn btn-sm me-2 present
                                    ${
                                      CheckIsPresent(item) &&
                                      "bg-success text-white"
                                    }`}
                                    onClick={() => {
                                      MarkStudentPresent(item.id);
                                      if (CheckAllStatus === "AllAbsent") {
                                        setCheckAllStatus("");
                                      }
                                    }}
                                  >
                                    Present
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>

                <div className="col-auto text-end float-end ms-auto download-grp submit-btn-container">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => {
                      CreateAttendance();
                    }}
                    disabled={FormDisabled}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
    </Fragment>
  );
};

export default AddAttendance;
